export const getOffset = (el: Element | HTMLDivElement) => {
  if (!el) return { left: 0, top: 0 };
  const rect = el.getBoundingClientRect();

  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
};
